"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, HStack, PinInput as ChakraPinInput, useBoolean, Box, } from "@chakra-ui/react";
import SvgSpriteConsumer from "../SvgSprite/SvgSpriteConsumer";
import { IconButton } from "../IconButton";
import { ButtonVariant } from "../Button";
import FieldHelpText from "../Input/FieldHelpText";
const PinInput = forwardRef((_a, ref) => {
    var { maskButtonVisible, children, isInvalid, errorMessage = "" } = _a, rest = __rest(_a, ["maskButtonVisible", "children", "isInvalid", "errorMessage"]);
    const [isMaskVisible, setIsMaskVisible] = useBoolean(false);
    return (_jsxs(_Fragment, { children: [_jsxs(HStack, Object.assign({ ref: ref }, { children: [_jsx(ChakraPinInput, Object.assign({ mask: isMaskVisible, placeholder: "0", isInvalid: isInvalid, focusBorderColor: "semantic.outline.focus", variant: isInvalid ? "error" : "default" }, rest, { children: children })), maskButtonVisible ? (_jsx(IconButton, { marginInlineStart: "3 !important", minW: "6", size: "md", icon: _jsx(SvgSpriteConsumer, { svgId: isMaskVisible ? "eyeCloseFilled24" : "eyeOpenFilled24", size: 24 }), variant: ButtonVariant.ICON, "aria-label": "eye-icon-button", onClick: setIsMaskVisible.toggle })) : null] })), isInvalid && errorMessage ? (_jsx(Box, Object.assign({ pt: "3" }, { children: _jsx(FieldHelpText, { text: errorMessage, variant: "error" }) }))) : null] }));
});
PinInput.displayName = "PinInput";
export default PinInput;
//# sourceMappingURL=PinInput.js.map